(ns frontend.ux-overhaul.table.helpers
  (:require
   [clojure.edn :as edn]
   [clojure.string :as string]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.state.current-session :as session]
  ))

(defn get-row-data-id
  [props]
  (:id (:data (js->clj props :keywordize-keys true))))

(defn kw->js
  [kw]
  (pr-str kw))

(defn js->kw
  [kw-str]
  (edn/read-string kw-str))

(defn multi-ref-renderer
  [entities]
  (let [entities (->> entities
                      (map (fn [t]
                             (if (:db/id t)
                               t
                               (session/get-entity t)))))
        entity-count (count entities)]
    (cond
      (zero? entity-count)
      "-"
      (> entity-count 5)
      (str (->> entities
                (map entity/display-string)
                (sort)
                (take 3)
                (string/join ", "))
           " and "
           (- entity-count 3)
           " others")
      :else
      (->> entities
           (map entity/display-string)
           (sort)
           (string/join ", ")))))

(defn multi-kw-renderer
  [kws]
  (let [kw-count (count kws)]
    (cond
      (zero? kw-count)
      "-"
      (> kw-count 5)
      (str (->> kws
                (map js->kw)
                (map loc/tr)
                (sort-by cu/str-trim-lcase)
                (take 3)
                (string/join ", "))
           " and "
           (- kw-count 3)
           " others")
      :else
      (->> kws
           (map js->kw)
           (map loc/tr)
           (sort-by cu/str-trim-lcase)
           (string/join ", ")))))


(defn multi-string-renderer
  [strs]
  (let [str-count (count strs)]
    (cond
      (zero? str-count)
      "-"
      (> str-count 5)
      (str (->> strs
                (sort-by cu/str-trim-lcase)
                (take 3)
                (string/join ", "))
           " and "
           (- str-count 3)
           " others")
      :else
      (->> strs
           (sort-by cu/str-trim-lcase)
           (string/join ", ")))))
